import axios from "axios";
import { storage } from "../../../helpers";
import { API_URL } from "../../../config";
import { MESSAGE } from "../../../constants";

export const exportXmlRequest = async (id) => {
    const token = storage.getToken();
    try {
        const response = await axios.get(`${API_URL}/documents/${id}/xml`, {
            params: { contentDispositionType: `attachment` },
            responseType: "blob",
            headers: {
                Accept: "application/xml",
                Authorization: `Bearer ${token}`,
            },
        });

        const contentDisposition = response.headers['content-disposition'];
        let filename = 'download.pdf';

        if (contentDisposition) {
            const match = contentDisposition.match(/filename="(.+?)"/);
            if (match && match[1]) {
                filename = match[1];
            }
        }

        const blob = new Blob([response.data], { type: "application/xml" });

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);

        link.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
    } catch (error) {
        console.error(MESSAGE.XML_EXPORT.error, error);
    }
};
